import { CanActivateFn, Router } from '@angular/router';
import { LoginService } from '../components/login/service/login.service';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(LoginService);
  const router = inject(Router);
    let userRole:any;
       let token = sessionStorage.getItem("token");
  if (authService.isAuthorizedUser && token) {
    return true;
  } else {
    router.navigate(['/login']);
    return false;
  }
  
};
